<template>
	<div>
		<section v-if="content" id="intro" class="main-content intro fade-animate">
			<div class="row">
				<slot name="content">
					<div class="columns column12 align-left">
						<div v-parse-links v-html="content" />
						<slot name="extra-content" />
					</div>
				</slot>
			</div>
			<slot name="bgImage">
				<div />
			</slot>
		</section>

		<slot />
	</div>
</template>

<script setup>
defineProps({
	content: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.content-wide #intro {
	.row {
		max-width: 960px;

		:deep(p) {
			max-width: 100%;
		}
	}
}

#intro {
	transition:
		opacity 0.3s ease,
		transform 0.3s ease-in-out;
	transform: translate3d(0, 5%, 0);

	&.active {
		transform: translate3d(0, 0, 0);
	}

	.row {
		display: flex;
		flex-flow: row wrap;
		justify-content: center;
		align-items: center;
		max-width: 860px;

		:deep(h2) {
			font-size: 35px;
			line-height: 45px;
			text-align: center;
			font-family: var(--body-font-family);
			font-weight: 300;
		}

		:deep(p) {
			width: 100%;
			max-width: 550px;
			margin: 0 auto 20px;
		}

		.align-center h1,
		.align-center h2 {
			margin-left: auto;
			margin-right: auto;
		}
	}
}

@media (max-width: 880px) {
	#intro {
		.row {
			h2,
			:deep(h2) {
				font-size: 28px;
				line-height: 35px;
			}
		}
	}
}
</style>
